import type { PageModalLinkProps } from "./page-modal-link.type";

import { Link, useLocation } from "react-router";

const PageModalLink = ({
  to,
  state,
  modalState,
  ...linkProps
}: PageModalLinkProps) => {
  const location = useLocation();
  const toProps = typeof to === "string" ? { pathname: to } : (to ?? {});

  return (
    <Link
      {...linkProps}
      to={toProps}
      state={{
        ...state,
        pageModal: {
          // By default, add current location to pageModal state to keep this page
          // in the background of the modal. backgroundLocation can also be overridden.
          backgroundLocation: location,
          ...modalState,
        },
      }}
    />
  );
};

export default PageModalLink;
